import React, { memo } from 'react';

import {
  Modal,
  Typography,
} from 'antd';

import { modalBodyStyle } from '../../../../../components/ImgCrop/ImgCrop';
import ProfileItem from '../../../../../components/ProfileItem/ProfileItem';
import Loader from '../../../../../components/V2/Loader/Loader';
import { useTheme } from '../../../../../context/ThemeProvider';
import {
  useTQConnectServiceRequestChatRoomMessageById,
} from '../../../../../hooks/queries/tqConnectQueries/service-requests';

interface Props {
  serviceRequestId: string;
  roomId: string;
  messageId: string;
  isModalOpen: boolean;
  closeModal: () => void;
  goToUserProfile: (userId: string) => void;
}

const MessageInfoModal: React.FC<Props> = ({
  serviceRequestId,
  roomId,
  messageId,
  isModalOpen,
  closeModal,
  goToUserProfile,
}) => {
  const { colors: COLORS } = useTheme();

  const { data: message, isLoading } =
    useTQConnectServiceRequestChatRoomMessageById(
      serviceRequestId,
      roomId,
      messageId,
      isModalOpen,
    );

  const seenBy = message?.seenBy;

  return (
    <Modal
      title={
        <div className="activityPostModalTitleWrapper">
          <Typography.Title
            level={4}
            className="activityPostModalTitle"
            style={{ textAlign: 'left' }}>
            Seen by
          </Typography.Title>
        </div>
      }
      centered
      footer={null}
      visible={isModalOpen}
      onOk={closeModal}
      onCancel={closeModal}
      className="createPostModalv2 message-info-modal"
      bodyStyle={modalBodyStyle as React.CSSProperties}
      wrapClassName="createPostModalDialogv2"
      maskClosable={false}
      destroyOnClose>
      <div className="message-info__content">
        {isLoading ? (
          <Loader type="spinner" color={COLORS.ICON} />
        ) : (
          <div className="message-info__content__list slimScroll transparent">
            {seenBy?.length ? (
              seenBy?.map((member) => (
                <ProfileItem
                  key={member._id}
                  className="message-info__content__list__item"
                  title={member.name}
                  tooltip={member.name}
                  avatar={member.profilePicUrl}
                  avatarTitle={member.name}
                  avatarSize={40}
                  onClick={() => goToUserProfile(member._id)}
                  titleStyle={{ fontWeight: 500 }}
                  subtitleStyle={{ fontSize: 12 }}
                />
              ))
            ) : (
              <Typography.Paragraph type="secondary">
                Not viewed yet
              </Typography.Paragraph>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default memo(MessageInfoModal);
